import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { accountRoutes } from './account';
import { directoryRoutes } from './directory';
import { localizeRoutes } from '../utils/routeUtils';

import RedirectComponent from '../components/router/RedirectComponent';

import AloPage from '../components/pages/alo/AloPage';
import HomePage from '../components/pages/home/HomePage';
import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import HowItWorksPage from '../components/pages/howitworks/HowItWorksPage';
import AccountPage from '../components/pages/account/AccountPage';
import ContactRequestPage from '../components/pages/contactrequest/ContactRequestPage';
import FaqPage from '../components/pages/faq/FaqPage';
import CashbackDirectoryPage from '../components/pages/directory/CashbackDirectoryPage';
import ReductionDirectoryPage from '../components/pages/directory/ReductionDirectoryPage';
import LegalNoticePage from '../components/pages/legalnotice/LegalNoticePage';
import TermsPage from '../components/pages/terms/TermsPage';
import TermsOfSalesPage from '../components/pages/termsofsales/TermsOfSalesPage';
import PrivacyPolicyPage from '../components/pages/privacypolicy/PrivacyPolicyPage';
import MerchantCardPage from '../components/pages/merchantcard/MerchantCardPage';
import UnsubscribePage from '../components/pages/unsubscribe/UnsubscribePage';
import InterstitielComponent from '../components/pages/interstitiel/InterstitielComponent';
import ToolbarPage from '../components/pages/toolbar/ToolbarPage';
import ToolbarInstallationPage from '../components/pages/toolbar/ToolbarInstallationPage';
import FlashingTicketPage from '../components/pages/flashing-ticket/FlashingTicketPage';
import ValidationEbonPage from '../components/pages/ebon/ValidationEbonPage';
import ConfirmationEbonPage from '../components/pages/ebon/confirmation/ConfirmationEbonPage';
import ErrorEbonPage from '../components/pages/ebon/erreur/ErrorEbonPage';
import AloConfirmationPage from '../components/pages/alo/AloConfirmationPage';
import ConfirmationKycPage from '../components/pages/ebon/kyc/ConfirmationKycPage';
import ErrorPage from '../components/pages/error/ErrorPage';
import LoginChoicePage from '../components/pages/authentication/login-choice/LoginChoicePage';
import NonEligiblePage from '../components/pages/authentication/non-eligible/NonEligiblePage';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: HomePage
    },
    {
        path: PATH.HOW_IT_WORK_PATH,
        exact: true,
        component: HowItWorksPage
    },
    {
        path: `${PATH.MERCHANTPAGE_TYPE_PATH}:query`,
        component: MerchantCardPage
    },
    {
        path: PATH.CASHBACK_PATH,
        component: CashbackDirectoryPage
    },
    {
        path: PATH.REDUCTION_PATH,
        component: ReductionDirectoryPage
    },
    {
        path: PATH.ACCOUNT_PATH,
        component: AccountPage
    },
    {
        path: PATH.FAQ_PATH,
        exact: true,
        component: FaqPage
    },
    {
        path: PATH.LEGAL_NOTICE_PATH,
        exact: true,
        component: LegalNoticePage
    },
    {
        path: PATH.TERMS_PATH,
        exact: true,
        component: TermsPage
    },
    {
        path: PATH.TERMS_OF_SALES,
        exact: true,
        component: TermsOfSalesPage
    },
    {
        path: PATH.PRIVACY_POLICY_PATH,
        exact: true,
        component: PrivacyPolicyPage
    },
    {
        path: PATH.TOOLBAR_PATH,
        exact: true,
        component: ToolbarPage
    },
    {
        path: PATH.TOOLBAR_POST_INSTALL_PATH,
        exact: true,
        component: ToolbarInstallationPage
    },
    {
        path: PATH.CONTACTREQUEST_PATH,
        exact: true,
        component: ContactRequestPage
    },
    {
        path: `${PATH.UNSUBSCRIBE_PATH}/:email`,
        exact: true,
        component: UnsubscribePage
    },
    {
        path: `${PATH.INTERSTITIEL_CASHBACK_PATH}:partnerId/:clickSource/:username?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_CASHBACK_PATH}:partnerId/:clickSource/:browser?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_REDUCTION_PATH}:partnerId/:clickSource/:couponId?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_REDUCTION_PATH}:partnerId/:clickSource/:couponId?`,
        component: InterstitielComponent
    },
    {
        path: PATH.FLASHING_TICKET_PATH,
        exact: true,
        component: FlashingTicketPage
    },
    {
        path: `${PATH.EBON_VALIDATION_PATH}/:query`,
        exact: true,
        component: ValidationEbonPage
    },
    {
        path: `${PATH.EBON_CONFIRMATION_PATH}:orderId?`,
        exact: true,
        component: ConfirmationEbonPage
    },
    {
        path: `${PATH.EBON_ERROR_PATH}-:id:paiement?`,
        component: ErrorEbonPage
    },
    {
        path: PATH.ALO_PATH,
        exact: true,
        component: AloPage
    },
    {
        path: PATH.ALO_CONFIRMATION_PATH,
        exact: true,
        component: AloConfirmationPage
    },
    {
        path: PATH.KYC_CONFIRMATION_PATH,
        exact: true,
        component: ConfirmationKycPage
    },
    {
        path: PATH.LOGIN_PATH,
        exact: true,
        component: LoginChoicePage
    },
    {
        path: PATH.NON_ELIGIBLE_PATH,
        exact: true,
        component: NonEligiblePage
    },
    // Formulaires Darty (connexion, inscription, mot de passe oublié) décâblés au profit du
    // SSO Darty : les anciennes URL renvoient vers la page de choix de connexion
    {
        path: PATH.LOGIN_FORM_PATH,
        exact: true,
        to: PATH.LOGIN_PATH,
        component: RedirectComponent
    },
    {
        path: PATH.REGISTER_FORM_PATH,
        exact: true,
        to: PATH.LOGIN_PATH,
        component: RedirectComponent
    },
    {
        path: PATH.FORGOTTEN_PASSWORD_PATH,
        to: PATH.LOGIN_PATH,
        component: RedirectComponent
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: PATH.ERROR_PATH,
        exact: true,
        component: ErrorPage
    },
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: NotFoundPage
    }
];

/**
 * First level routes + sub levels routes
 * Mainly used for breadcrumb
 */
const subRoutes = [...accountRoutes, ...directoryRoutes];

export const allRoutes = [...routes, ...subRoutes, ...localizeRoutes(LOCALES, subRoutes)];



// WEBPACK FOOTER //
// ./src/routes/index.js